import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Template = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.82 4H20.18C21.19 4 22 4.82 22 5.82V18.18C22 19.19 21.18 20 20.18 20H3.82C2.81 20 2 19.18 2 18.18V5.82C2 4.81 2.81 4 3.82 4ZM20.18 18.75C20.5 18.75 20.75 18.49 20.75 18.18V5.82C20.75 5.5 20.49 5.25 20.18 5.25H3.82C3.5 5.25 3.25 5.51 3.25 5.82V18.18C3.25 18.5 3.51 18.75 3.82 18.75H20.18ZM11.38 8.74H6.38001C6.04001 8.74 5.76001 8.46 5.76001 8.12C5.76001 7.78 6.04001 7.5 6.38001 7.5H11.38C11.72 7.5 12 7.78 12 8.12C12 8.46 11.72 8.74 11.38 8.74ZM5.76001 12C5.76001 11.66 6.04001 11.38 6.38001 11.38H17.62C17.96 11.38 18.24 11.66 18.24 12C18.24 12.34 17.96 12.62 17.62 12.62H6.38001C6.04001 12.62 5.76001 12.34 5.76001 12ZM6.38001 15.26C6.04001 15.26 5.76001 15.54 5.76001 15.88C5.76001 16.22 6.04001 16.5 6.38001 16.5H17.62C17.96 16.5 18.24 16.22 18.24 15.88C18.24 15.54 17.96 15.26 17.62 15.26H6.38001Z"
    />
  </svg>
)

export default withDefaultStyles(Template)
